export default __webpack_public_path__ + "static/media/play-circle.67bd7378.svg";